import { Component, Input, OnInit } from '@angular/core';
import { BaryComponentHelper } from 'app/shared/util/bary-component-helper';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { IBaryInput } from 'models/bary-input';
import { CommonModule } from '@angular/common';
import { InputsModule, InputUtilitiesModule, MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { MarkAsteriskDirective } from '../../../../directives/mark-asterisk.directive';
import { TranslateDirective } from '../../../../directives/translate.directive';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-bary-input-textarea',
  templateUrl: './bary-input-textarea.component.html',
  styleUrls: ['./bary-input-textarea.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, InputUtilitiesModule, InputsModule, MDBBootstrapModulesPro, MarkAsteriskDirective, TranslateDirective, BaryIconComponent],
})
export class BaryInputTextareaComponent implements IBaryInput, OnInit {
  @Input() id: string = BaryComponentHelper.makeId();
  @Input() placeholder?: string;
  @Input() label?: string;
  @Input() icon?: string;
  @Input() name?: string;
  @Input() disabled: boolean = false;
  @Input() rows: number = 3;
  @Input() maxLength: number = 350;

  @Input() control = new FormControl('');

  protected readonly FAR = FaDirectiveEnum.FAR;

  ngOnInit(): void {
    this.control.addValidators([Validators.pattern('[^|]*')]);
  }
}
